import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { __ } from '@wordpress/i18n';

domReady(() => {
  const interestsCarousels = document.querySelectorAll(
    '.member-interests-swiper'
  );

  const initializeSwiper = () => {
    interestsCarousels.forEach((carousel) => {
      const navigationWrapper = carousel
        .closest('.member-interests-block')
        .querySelector('.vtx-swiper__navigation');

      new Swiper(carousel, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        navigation: {
          nextEl: navigationWrapper.querySelector('.vtx-swiper__next'),
          prevEl: navigationWrapper.querySelector('.vtx-swiper__prev'),
        },
      });
    });
  };

  if (0 < interestsCarousels.length) {
    initializeSwiper();
  }

  window.addEventListener('resize', () => {
    initializeSwiper();
  });

  // Initialize member advisors swiper for mobile
  const initializeAdvisorsSwiper = () => {
    const advisorsContainer = document.querySelector('[data-swiper-mobile]');

    if (!advisorsContainer) return;

    // Destroy existing swiper instance if any
    if (advisorsContainer.swiper) {
      advisorsContainer.swiper.destroy(true, true);
    }

    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;

    if (isMobile) {
      // Initialize swiper only on mobile
      new Swiper(advisorsContainer, {
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        loop: false,
        navigation: {
          nextEl: advisorsContainer.querySelector('.swiper-button-next'),
          prevEl: advisorsContainer.querySelector('.swiper-button-prev'),
        },
        on: {
          init() {
            updateCustomPagination(this);
          },
          slideChange() {
            updateCustomPagination(this);
          },
        },
      });

      // Function to update custom pagination
      function updateCustomPagination(swiper) {
        const currentSlideEl =
          advisorsContainer.querySelector('.current-slide');
        const totalSlidesEl = advisorsContainer.querySelector('.total-slides');

        if (currentSlideEl && totalSlidesEl) {
          const currentIndex = swiper.activeIndex + 1;
          const totalSlides = swiper.slides.length;

          currentSlideEl.textContent = currentIndex.toString().padStart(2, '0');
          totalSlidesEl.textContent = totalSlides.toString().padStart(2, '0');
        }
      }
    }
  };

  // Initialize advisors swiper on load
  initializeAdvisorsSwiper();

  // Re-initialize on window resize
  window.addEventListener('resize', () => {
    initializeAdvisorsSwiper();
  });

  //Handle footer items visibility based on user login status
  const footerItems = document.querySelectorAll(
    '.site-footer__widgets__item:not(.contact-info):not(.microsite-widget)'
  );
  const handleFooterItems = (item, loggedIn) => {
    const title = item.querySelector('.site-footer__widgets__item__title');
    const description = item.querySelector(
      '.site-footer__widgets__item__description--text'
    );
    const btn = item.querySelector('.wp-block-button');
    if (loggedIn) {
      if (title) {
        title.textContent = item.getAttribute('data-title-logged-in') || '';
      }
      if (description) {
        description.textContent =
          item.getAttribute('data-description-logged-in') || '';
      }
      if (btn) {
        btn.classList.add('hidden');
      }
    } else {
      if (title) {
        title.textContent = item.getAttribute('data-title') || '';
      }
      if (description) {
        description.textContent = item.getAttribute('data-description') || '';
      }
      if (btn) {
        btn.classList.remove('hidden');
      }
    }
  };

  // Handle navbar buttons visibility based on user login status
  const navBarButtons = document.querySelectorAll('.navbar__buttons a');
  const handleNavBarButtons = (button, loggedIn) => {
    if (button.classList.contains('header-member-area-btn')) {
      button.classList.remove('loading');
      const buttonText = button.querySelector('.header-member-area-btn__text');
      if (buttonText) {
        buttonText.textContent = loggedIn
          ? __('Hello !', 'vtx')
          : __('Member Area', 'vtx');
      }
    } else {
      button.classList.toggle('hidden', loggedIn);
    }
  };

  // Handle footer items and navbar buttons based on user login status
  const handleLoggedInItems = (loggedIn) => {
    if (footerItems.length > 0) {
      footerItems.forEach((item) => {
        handleFooterItems(item, loggedIn);
      });
    }
    if (navBarButtons.length > 0) {
      navBarButtons.forEach((button) => {
        handleNavBarButtons(button, loggedIn);
      });
    }
  };

  // Fetch user login status from the server
  fetch('/wp-admin/admin-ajax.php?action=check_user_logged_in')
    .then((response) => response.json())
    .then((data) => {
      handleLoggedInItems(data.is_user_logged_in);
    })
    .catch((error) => {
      handleLoggedInItems(false);
      console.error('Error fetching user login status:', error);
    });
});
